<template>
<div class="container">
<b-row >
	<md-table-cell class="col-sm text-center border"><h3><b><i>{{f_titulo()}}</i></b></h3></md-table-cell>
</b-row>
<b-row v-if="!isLoading">
<md-table-cell class="col-sm text-center">
	<h3>
	<label for="desde">Desde</label> &nbsp;
	<input type="date" name="" id="desde" v-model="desde" @click="desde='';hasta='';pais='';paises=false;fgl_mensaje=false;">&nbsp; 
	<label for="hasta">Hasta</label> &nbsp;
	<input type="date" name="" id="hasta" v-model="hasta" @click="hasta='';pais='';paises=false" @input="f_seleccione_pais()">&nbsp; 
	<label v-if="paises">País</label>
	<select v-if="paises" v-model="pais">
		<option
			v-for="(item, idx) in listPaises"
			:key="idx"
			:value="item.pais">
			{{item.pais}}
		</option>
	</select> &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;

	</h3>
</md-table-cell>
</b-row>
<b-row>
<md-table-cell class="col-sm text-center">
	<md-button v-if="desde && hasta && pais && base==true" class="md-primary md-raised" @click="f_consulta_informacion(true)"><h3>Consulta</h3></md-button>
	<md-button v-if="desde && hasta && pais && base==false" class="md-primary md-raised" @click="f_consulta_informacion(true)"><h3>Todos</h3></md-button>
	<md-button v-if="desde && hasta && pais && base==false" class="md-primary md-raised" @click="f_consulta_informacion(false)"><h3>Cantidades</h3></md-button>
</md-table-cell>
</b-row>
<b-row v-if="fgl_mensaje">
	<md-table-cell class="col-sm text-center border"><h3><b><i>Reporte en Progreso...............</i></b></h3></md-table-cell>
</b-row>
</div>
</template>
<script>
import Novedades from "@/services/Novedades"
import * as XLSX from "exceljs"

export default {
name:'Reportes',
data: () => ({
	isLoading: false,
	base: false,
	fgl_mensaje: false,
	pais: '',
	paises: false,
	users : [],
	listPaises : [],
	listFacturas : [],
	listNovedades : [],
	desde: '',
	hasta: '',
	recarga: '',
}),
computed:{
},
mounted(){
	Novedades.leaPaises(null)
	.then((res) => {
		this.listPaises = res.data.listPaises
		this.pais=''
		if	(this.listPaises.lenght==0) {
			this.paises=false
		}
	})
	if	(this.$route.name == "Rnovedades") {
		this.base=true
	}

},
methods:{
	f_titulo() {
		let v_titulo=''
		if	(this.$route.name == "Rnovedades") {
			v_titulo="REPORTE REGISTRO DE CONTABILIZACIONES"
			return v_titulo
		}
		if	(this.$route.name == "RESnovedades") {
			v_titulo="NOVEDADES EN REGISTRO DE CONTABILIZACIONES"
			return v_titulo
		}
	},
	f_seleccione_pais() {
		this.paises=true
	},
	f_consulta_informacion(p_todos) {
		this.fgl_mensaje=true
		if	(this.$route.name == "Rnovedades") {
			Novedades.leaInformacionReporte(this.pais,this.desde,this.hasta)
			.then((result) => {
				this.listFacturas = result.data.listFacturas
			})
			.then(() => {
				this.descargueInformacion()
				this.fgl_mensaje=false
			})
			.catch((err) => {
				console.log(err)
				this.$toast.error("Problema al leer Informacion")
			})
		}
		if	(this.$route.name == "RESnovedades") {
			Novedades.leaInformacionRepNovedades(this.pais,this.desde,this.hasta,p_todos)
			.then((result) => {
				this.listNovedades = result.data.listNovedades
			}).
			then(() => {
				this.descargueNovedades()
				this.fgl_mensaje=false
			})
			.catch((err) => {
				console.log(err)
				this.$toast.error("Problema al leer Informacion")
			})
		}
	},
	async descargueInformacion() {
		let createdAt1 = new Date()
		let anio = createdAt1.getFullYear()
		let mes = createdAt1.getMonth()+1
		let dia = createdAt1.getDate()
		let createdAt = anio+"-"+mes+"-"+dia

		let titulo = "BPO "+this.pais+
			" INFORMACION DESDE "+this.desde+
			" HASTA "+this.hasta
		let userName = this.$store.state.userName

		const {Workbook} = XLSX
		const workbook = new Workbook()
		const worksheet = workbook.addWorksheet("Registro")

		const ENCABEZADO1 = [
			titulo
		]
		worksheet.addRow(ENCABEZADO1)
		const ENCABEZADO3 = [
			"Creado "+createdAt+" por "+userName,
		]
		worksheet.addRow(ENCABEZADO3)
		const ENCABEZADO5 = [
		]
		worksheet.addRow(ENCABEZADO5)
		
		const HEADER_ROW = [
			"Fecha",
			"Documento",
			"Car-Sunat",
			"Identificacion",
			"Nombre",
			"Estado",
			"BPO",
			"Pedido",
			"Documento Contable",
			"Observaciones",
		]
		worksheet.addRow(HEADER_ROW)
		
		this.listFacturas.forEach((factura) => {
			if	(factura.bpo == null) {
				factura.bpo=factura.bpo_client
				factura.descripcion=factura.bpo_estado
			}
			const v_fila = [
				factura.fecha,
				factura.factura,
				factura.car_sunat,
				factura.identificacion,
				factura.razon_social,
				factura.descripcion,
				factura.bpo,
				factura.pedido,
				factura.documento_contable,
				factura.observaciones,
			]
			worksheet.addRow(v_fila)
		})

		const file = await workbook.xlsx.writeBuffer()
		const downloadLink = document.createElement("a")
		downloadLink.download = "BPO "+this.desde+"-"+this.hasta+".xlsx"
		downloadLink.href = window.URL.createObjectURL(
			new Blob([file], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			})
		)

		downloadLink.style.display = "none";

		document.body.appendChild(downloadLink);
		downloadLink.click();

		downloadLink.remove();
		
	},
	async descargueNovedades() {
		let createdAt1 = new Date()
		let anio = createdAt1.getFullYear()
		let mes = createdAt1.getMonth()+1
		let dia = createdAt1.getDate()
		let createdAt = anio+"-"+mes+"-"+dia

		let titulo = "NOVEDADES "+this.pais+
			" INFORMACION DESDE "+this.desde+
			" HASTA "+this.hasta
		let userName = this.$store.state.userName

		const {Workbook} = XLSX
		const workbook = new Workbook()
		const worksheet = workbook.addWorksheet("Novedades")

		const ENCABEZADO1 = [
			titulo
		]
		worksheet.addRow(ENCABEZADO1)
		const ENCABEZADO3 = [
			"Creado "+createdAt+" por "+userName,
		]
		worksheet.addRow(ENCABEZADO3)
		const ENCABEZADO5 = [
		]
		worksheet.addRow(ENCABEZADO5)
		
		const HEADER_ROW = [
				"Tipo Novedad",
				"Fecha Novedad",
				"Pedido",
				"Documento",
				"Factura",
				"Valor Total",
				"Descripcion",
				"Ruc Proveedor",
				"Llave",
				"Analista",
				"Razon Social",
				"Item",
				"Precio Unitario",
				"Cantidad FE",
				"Cantidad SAP",
				"Diferencia Cantidad",
				"Sub Total",
				"IGV",
				"Detraccion",
				"Total",
				"Documento Contable",
				"Estado",
				"Comentario",
		]
		worksheet.addRow(HEADER_ROW)

		this.listNovedades.forEach((novedad) => {
			const v_fila = [
				novedad.tipo_novedad,
				novedad.fecha_novedad,
				novedad.pedido,
				novedad.documento,
				novedad.factura,
				novedad.valor_total,
				novedad.descripcion,
				novedad.rut_proveedor,
				novedad.llave,
				novedad.analista,
				novedad.razon_social,
				novedad.item,
				novedad.precio_unitario,
				novedad.cantidad_fe,
				novedad.cantidad_sap,
				novedad.diferencia_cantidad,
				novedad.subtotal,
				novedad.iva,
				novedad.detraccion,
				novedad.total,
				novedad.documento_contable,
				novedad.estado,
				novedad.comentario,
			]
			worksheet.addRow(v_fila)
		})

		const file = await workbook.xlsx.writeBuffer()
		const downloadLink = document.createElement("a")
		downloadLink.download = "NOVEDADES "+this.desde+"-"+this.hasta+".xlsx"
		downloadLink.href = window.URL.createObjectURL(
			new Blob([file], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			})
		)

		downloadLink.style.display = "none";

		document.body.appendChild(downloadLink);
		downloadLink.click();

		downloadLink.remove();

	},
}

}
</script>

<style>

</style>
